module.exports = __webpack_public_path__ + "img/brick-vertical.4abb8999.svg";